import React from 'react';
import { Link } from 'react-router-dom';
import ConversionLink from './ConversionLink';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-container container">
        <Link to="/" className="header-logo">
          <span>SheetPilot</span>
        </Link>
        <ConversionLink 
          href="https://buy.stripe.com/8x2cN51kR1ORdKQdg85Ne02" 
          className="header-cta btn btn-primary"
        >
          Get Access – $10
        </ConversionLink>
      </div>
    </header>
  );
}

export default Header;
